import { Colors } from '@/constants/theme';
import { useColorScheme } from '@/hooks/use-color-scheme';

export function useThemeColor(
  props: { light?: string; dark?: string },
  colorName: keyof typeof Colors.light & keyof typeof Colors.dark,
) {
  const { colorScheme } = useColorScheme();
  const theme = colorScheme ?? 'dark';
  const colorFromProps = props[theme];

  return colorFromProps ?? Colors[theme][colorName];
}
